import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-subAgent",
  "use": "icon-subAgent-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-subAgent\"><defs><style type=\"text/css\"></style></defs><path d=\"M208.7 651.6C147.8 668.2 98 723.5 98 789.9c0 77.5 60.8 138.3 138.3 138.3s138.3-60.8 138.3-138.3c0-72-49.8-127.3-110.7-138.3V540.9h498v110.7c-60.8 16.6-110.7 72-110.7 138.3 0 77.5 60.8 138.3 138.3 138.3S928 867.4 928 789.9c0-72-49.8-127.3-110.7-138.3V540.9c0-33.2-22.2-55.3-55.3-55.3H540.7V374.9c60.8-16.6 110.7-72 110.7-138.3 0-77.5-60.8-138.3-138.3-138.3s-138.3 60.8-138.3 138.3c0 72 49.8 127.3 110.7 138.3v110.7H264c-33.2 0-55.3 22.2-55.3 55.3v110.7z\" p-id=\"8280\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/subAgent.svg
// module id = tJ6z
// module chunks = 144